import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CarsNotFoundSVG } from "../../../contents/svgs/carDetails";
function CarsNotFound(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CarsNotFoundSVG />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.ErrorMessage) {
    t1 = <div className="car-not-found">{t0}<p>{props.ErrorMessage}</p></div>;
    $[1] = props.ErrorMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default CarsNotFound;